export const logFailureTo = (attemptedAction: string) => (e: Error) =>
  console.error(`Failed to ${attemptedAction}: ${e.message}`)
